import { createSlice } from '@reduxjs/toolkit';
import { store } from '../store';
import persistStore from 'redux-persist/es/persistStore';

const initialState = {
  open: false,
  show: false,
  selectedSession: null,
  range: [null, null],
  search: '',
  currentPage: 1,
  rowsPerPage: 200,
  sortField: null,
  sortDirection: false,
  dropdownDataStore: [],
  isNext: false
};

export const hrxAttendanceSlice = createSlice({
  name: 'hrxAttendanceSlice',
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
      state.currentPage = 1;
    },
    setSortField: (state, action) => {
      state.sortField = action.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },
    setDropdownData: (state, action) => {
      state.dropdownDataStore = [...state.dropdownDataStore, ...action.payload];
    },
    setIsNext: (state, action) => {
      state.isNext = action.payload;
    },
    setRange: (state, action) => {
      state.range = action.payload?.length === 2 ? action.payload : [null, null];
    },
    setOpen: (state, action) => {
      state.open = action.payload;
    },
    setSessionShow: (state, action) => {
      state.show = action.payload;
    },
    setSelectedSession: (state, action) => {
      state.selectedSession = action.payload;
    },
    resetState: () => {
      return { ...initialState };
    }
  }
});

export const {
  setSearch,
  setCurrentPage,
  setRowsPerPage,
  setSortField,
  setSortDirection,
  setDropdownData,
  setIsNext,
  setOpen,
  setRange,
  setSessionShow,
  setSelectedSession,
  resetState
} = hrxAttendanceSlice.actions;

export const { reducer: hrxAttendanceReducer } = hrxAttendanceSlice;

export const resetHrxAttendanceState = () => (dispatch) => {
  const persistor = persistStore(store);
  persistor.pause(); // Stop rehydration
  persistor.purge(); // Clear persisted state
  persistor.flush().then(() => {
    dispatch(resetState()); // Reset Redux state after flush
  });
};
